var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadInPocketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_2_",
    d: "M19.133,0.002c-1.079,0-2.151,0.441-2.914,1.198c-0.763,0.757-1.207,1.82-1.207,2.89 v119.822c0,1.07,0.444,2.134,1.207,2.89c0.763,0.757,1.835,1.198,2.914,1.198h89.734c1.079,0,2.151-0.441,2.914-1.198 c0.763-0.757,1.207-1.82,1.207-2.89c0-30.989,0-61.977,0-92.965c-0.117-1.197-0.552-2.405-1.271-3.114L83.643,1.135 c-0.737-0.696-1.742-1.106-2.76-1.126C60.323-0.006,39.711,0.002,19.133,0.002L19.133,0.002z M23.254,8.178h53.418v22.61 c0,1.07,0.444,2.134,1.207,2.89c0.763,0.757,1.835,1.198,2.914,1.198h23.953c0,28.321,0,56.645,0,84.949H23.254V8.178z  M84.914,13.838L98.444,26.7h-13.53V13.838z M65.053,103.369H32.396v-6.047h32.658V103.369z M95.604,87.567H32.396V81.52h63.209 V87.567z M95.604,71.765H32.396v-6.047h63.209V71.765z M95.604,55.962H32.396v-6.047h63.209V55.962z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadInPocketIcon);
export default __webpack_public_path__ + "static/media/read-in-pocket-icon.422899cf71c851a03e547c59f3cfa94f.svg";
export { ForwardRef as ReactComponent };